/* globals ResponsiveUtil */

import CookieSet from 'common/util/CookieSet';
import { component } from 'common/util/ComponentDecorator';

@component
export default class product {
	static classname = 'product';

	constructor($product) {
		this.$product = $product;
		this.recentSet = CookieSet('shop_recently');

		this.init();
		this.bindEvents();
	}

	get id() {
		return this.$product.data('id');
	}

	init() {
		this.recentSet.add(this.id);
	}

	bindEvents() {
		this.$product.find('a[href="#reviews"]').on('click', function (e) {
			const $reviews = $('.product-reviews');
			const is_add_trigger = $(this).data('add-trigger');
			if (is_add_trigger) {
				const component = $reviews.data('component');
				if (component && component.openForm) {
					component.openForm();
				}
			}
		});

		this.$product.find('a[href="#page_faq"]').on('click', function (e) {
			const $que = $('.que-plugin');
			const is_add_trigger = $(this).data('add-trigger');

			if (is_add_trigger) {
				const component = $que.data('component');
				if (component && component.openModal) {
					component.openModal();
				}
			}
		});

		this.$product.find('.js-out-of-page').on('click', function() {
			const $prevBreadcrumbBlock = $('.breadcrumbs__item_prev');

			if ($prevBreadcrumbBlock.length > 0) {
				$prevBreadcrumbBlock.find('.breadcrumbs__item-link').get(0).click();
			}
		})
	}
}
